import axios from "axios";
import params from "../../../config/params";

require("dotenv").config();

let BASE_URL = params.PROD.CLIENT.RETURN_SOLICITATION.ITEMS.BASE_URL;

if (process.env.NODE_ENV === "development") {
  BASE_URL = params.DEV.CLIENT.RETURN_SOLICITATION.ITEMS.BASE_URL;
}
if (process.env.NODE_ENV === "qa") {
  BASE_URL = params.QA.CLIENT.RETURN_SOLICITATION.ITEMS.BASE_URL;
}

const getItemsList = async () => {
  return axios
    .get(`${BASE_URL}/all`)
    .then(res => {
      return res;
    })
    .catch(error => {
      return error;
    });
};

export default {
  getItemsList
};
